import List from './List/homepageWidgetslist';
import Edit from './Edit/edit';
import Add from './Add/add';

export default {
  List,
  Edit,
  Add
};
